import { Flex, Tag } from 'antd'

import { OrderCountdown } from '@eastcoal/shared/components/OrderCountdown'
import {
  OrderStatus,
  OrderStatusBuyerTextMap,
  OrderStatusColorMap
} from '@eastcoal/shared/enums/OrderStatus'

import { OrderListStatusRenderProps } from './interface'

export const OrderListStatusRender = ({
  record
}: OrderListStatusRenderProps) => {
  const { status = OrderStatus.WAIT_SELLER_CONFIRM } = record

  return (
    <Flex vertical align='center' justify='center'>
      <Tag color={OrderStatusColorMap[status]}>
        {OrderStatusBuyerTextMap[status]}
      </Tag>
      <OrderCountdown record={record} />
    </Flex>
  )
}
